/* TA DROPS V2 — interactions */
(function () {
  'use strict';
  var RM = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Hero slideshow ---------- */
  function Hero(root) {
    var slides = root.querySelectorAll('.tad-slide');
    if (!slides.length) return;
    var pips = root.querySelectorAll('.tad-pip');
    var bar = root.querySelector('.tad-prog__bar');
    var count = root.querySelector('.tad-hero__count');
    var pauseBtn = root.querySelector('[data-hero-pause]');
    var dur = parseInt(root.getAttribute('data-interval') || '5000', 10);
    var auto = root.getAttribute('data-autoplay') !== 'false' && !RM && slides.length > 1;
    var i = 0, timer = null, hold = false, userPaused = false, started = 0, remain = dur;
    root.style.setProperty('--tad-dur', dur + 'ms');

    function tone() { root.setAttribute('data-tone', slides[i].getAttribute('data-tone') || 'light'); }
    function runBar() {
      if (!bar) return;
      bar.classList.remove('is-run'); void bar.offsetWidth;
      if (auto && !userPaused) bar.classList.add('is-run');
    }
    function go(n, fromUser) {
      var prev = i;
      i = (n + slides.length) % slides.length;
      slides.forEach(function (s, k) {
        var on = k === i;
        s.classList.toggle('is-active', on);
        s.setAttribute('aria-hidden', on ? 'false' : 'true');
        s.querySelectorAll('a,button').forEach(function (el) { if (!on) el.setAttribute('tabindex', '-1'); else el.removeAttribute('tabindex'); });
        if (!on) s.querySelectorAll('video').forEach(function (v) { v.pause(); });
        else s.querySelectorAll('video[data-autoplay]').forEach(function (v) { if (!RM) { var p = v.play(); if (p && p.catch) p.catch(function () {}); } });
      });
      pips.forEach(function (p, k) {
        p.setAttribute('aria-current', k === i ? 'true' : 'false');
        if (k === i && prev !== i && !RM) { p.classList.remove('is-flip'); void p.offsetWidth; p.classList.add('is-flip'); }
      });
      if (count) count.textContent = '0' + (i + 1) + ' / 0' + slides.length;
      tone();
      remain = dur; schedule(); runBar();
    }
    function schedule() {
      clearTimeout(timer);
      if (!auto || hold || userPaused) return;
      started = Date.now();
      timer = setTimeout(function () { go(i + 1); }, remain);
    }
    function pause() {
      if (hold) return; hold = true;
      remain = Math.max(400, remain - (Date.now() - started));
      clearTimeout(timer); root.classList.add('is-paused');
    }
    function resume() {
      if (!hold) return; hold = false;
      if (!userPaused) root.classList.remove('is-paused');
      schedule();
    }
    pips.forEach(function (p, k) { p.addEventListener('click', function () { go(k, true); }); });
    var nx = root.querySelector('[data-hero-next]'), pv = root.querySelector('[data-hero-prev]');
    if (nx) nx.addEventListener('click', function () { go(i + 1, true); });
    if (pv) pv.addEventListener('click', function () { go(i - 1, true); });
    if (pauseBtn) {
      if (!auto) pauseBtn.hidden = true;
      pauseBtn.addEventListener('click', function () {
        userPaused = !userPaused;
        pauseBtn.setAttribute('aria-pressed', userPaused ? 'true' : 'false');
        pauseBtn.setAttribute('aria-label', userPaused ? 'Play slideshow' : 'Pause slideshow');
        pauseBtn.querySelector('span').textContent = userPaused ? '▶' : 'II';
        root.classList.toggle('is-paused', userPaused);
        if (userPaused) { clearTimeout(timer); } else { remain = dur; schedule(); runBar(); }
      });
    }
    root.addEventListener('mouseenter', pause);
    root.addEventListener('mouseleave', resume);
    root.addEventListener('focusin', pause);
    root.addEventListener('focusout', function (e) { if (!root.contains(e.relatedTarget)) resume(); });
    root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { go(i + 1, true); } else if (e.key === 'ArrowLeft') { go(i - 1, true); }
    });
    var sx = null;
    root.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; pause(); }, { passive: true });
    root.addEventListener('touchend', function (e) {
      if (sx !== null) { var dx = e.changedTouches[0].clientX - sx; if (Math.abs(dx) > 45) go(i + (dx < 0 ? 1 : -1), true); }
      sx = null; resume();
    });
    document.addEventListener('visibilitychange', function () { if (document.hidden) pause(); else resume(); });
    go(0);
  }

  /* ---------- Mega menu ---------- */
  function Mega(btn) {
    var panel = document.getElementById(btn.getAttribute('aria-controls'));
    if (!panel) return;
    var wrap = btn.closest('[data-mega-wrap]') || btn.parentNode;
    var t = null;
    function open() { clearTimeout(t); btn.setAttribute('aria-expanded', 'true'); panel.classList.add('is-open'); }
    function close() { clearTimeout(t); btn.setAttribute('aria-expanded', 'false'); panel.classList.remove('is-open'); }
    btn.addEventListener('click', function (e) { e.preventDefault(); if (btn.getAttribute('aria-expanded') === 'true') close(); else open(); });
    var hoverable = window.matchMedia('(hover: hover)').matches;
    if (hoverable) {
      btn.addEventListener('mouseenter', function () { t = setTimeout(open, 80); });
      btn.addEventListener('mouseleave', function () { clearTimeout(t); t = setTimeout(function(){ if (!panel.matches(':hover') && !btn.matches(':hover')) close(); }, 160); });
      panel.addEventListener('mouseleave', function () { t = setTimeout(function(){ if (!btn.matches(':hover')) close(); }, 160); });
      panel.addEventListener('mouseenter', function () { clearTimeout(t); });
    }
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && btn.getAttribute('aria-expanded') === 'true') { close(); btn.focus(); } });
    document.addEventListener('click', function (e) { if (!panel.contains(e.target) && !btn.contains(e.target)) close(); });
    panel.addEventListener('focusout', function (e) { if (e.relatedTarget && !panel.contains(e.relatedTarget) && e.relatedTarget !== btn) close(); });
    btn.addEventListener('keydown', function (e) { if (e.key === 'ArrowDown') { e.preventDefault(); open(); var f = panel.querySelector('a'); if (f) f.focus(); } });
  }

  /* ---------- Mobile drawer ---------- */
  function Drawer(d) {
    var last = null;
    function open() { last = document.activeElement; d.classList.add('is-open'); d.setAttribute('aria-hidden', 'false'); document.documentElement.style.overflow = 'hidden'; var f = d.querySelector('[data-drawer-close]'); if (f) f.focus(); }
    function close() { d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true'); document.documentElement.style.overflow = ''; if (last) last.focus(); }
    document.querySelectorAll('[data-drawer-open="' + d.id + '"]').forEach(function (b) { b.addEventListener('click', function(){ b.setAttribute('aria-expanded','true'); open(); }); });
    d.querySelectorAll('[data-drawer-close]').forEach(function (b) { b.addEventListener('click', function(){ document.querySelectorAll('[data-drawer-open="' + d.id + '"]').forEach(function(x){x.setAttribute('aria-expanded','false');}); close(); }); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && d.classList.contains('is-open')) close(); });
  }

  /* ---------- Lite YouTube ---------- */
  function Lite(btn) {
    btn.addEventListener('click', function () {
      var id = btn.getAttribute('data-yt');
      if (!id) return;
      var f = document.createElement('iframe');
      f.src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(id) + '?autoplay=1&rel=0&modestbranding=1&playsinline=1';
      f.title = btn.getAttribute('aria-label') || 'YouTube video';
      f.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
      f.allowFullscreen = true;
      btn.innerHTML = ''; btn.appendChild(f); btn.style.cursor = 'default';
      var hero = btn.closest('[data-tad-hero]');
      if (hero) { var pb = hero.querySelector('[data-hero-pause]'); if (pb && pb.getAttribute('aria-pressed') !== 'true') pb.click(); }
    }, { once: true });
  }

  /* ---------- Rails ---------- */
  function Rail(wrap) {
    var rail = wrap.querySelector('.tad-rail');
    if (!rail) return;
    var p = wrap.querySelector('[data-rail-prev]'), n = wrap.querySelector('[data-rail-next]');
    function by(d) { rail.scrollBy({ left: d * rail.clientWidth * 0.9, behavior: RM ? 'auto' : 'smooth' }); }
    if (p) p.addEventListener('click', function () { by(-1); });
    if (n) n.addEventListener('click', function () { by(1); });
  }

  function init(scope) {
    scope = scope || document;
    scope.querySelectorAll('[data-tad-hero]').forEach(function (el) { if (!el.__tad) { el.__tad = 1; Hero(el); } });
    scope.querySelectorAll('[data-mega-toggle]').forEach(function (el) { if (!el.__tad) { el.__tad = 1; Mega(el); } });
    scope.querySelectorAll('.tad-drawer').forEach(function (el) { if (!el.__tad) { el.__tad = 1; Drawer(el); } });
    scope.querySelectorAll('.tad-lite[data-yt]').forEach(function (el) { if (!el.__tad) { el.__tad = 1; Lite(el); } });
    scope.querySelectorAll('[data-tad-rail]').forEach(function (el) { if (!el.__tad) { el.__tad = 1; Rail(el); } });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var s = e.target.closest('.tad-slide'); if (!s) return;
    var hero = s.closest('[data-tad-hero]'); var idx = Array.prototype.indexOf.call(hero.querySelectorAll('.tad-slide'), s);
    var pip = hero.querySelectorAll('.tad-pip')[idx]; if (pip) pip.click();
  });
})();

/* ===== V2.1: marquee toggle, tilt, product image framing ===== */
(function () {
  var RM = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function marquee(root) {
    (root || document).querySelectorAll('[data-tad-marquee]').forEach(function (m) {
      if (m.__tadm) return; m.__tadm = 1;
      var b = m.querySelector('[data-marquee-toggle]'); if (!b) return;
      b.addEventListener('click', function () { var p = m.classList.toggle('is-paused'); b.setAttribute('aria-pressed', p ? 'true' : 'false'); });
    });
  }
  function tilt(root) {
    if (RM || !(window.matchMedia && window.matchMedia('(hover: hover)').matches)) return;
    (root || document).querySelectorAll('[data-tad-tilt]').forEach(function (el) {
      if (el.__tadt) return; el.__tadt = 1;
      var host = el.closest('section') || el;
      host.addEventListener('pointermove', function (e) {
        var r = el.getBoundingClientRect(); if (!r.width) return;
        var x = Math.max(-.5, Math.min(.5, (e.clientX - r.left) / r.width - .5)), y = Math.max(-.5, Math.min(.5, (e.clientY - r.top) / r.height - .5));
        el.style.setProperty('--ry', (x * 10).toFixed(2) + 'deg'); el.style.setProperty('--rx', (-y * 8).toFixed(2) + 'deg');
      });
      host.addEventListener('pointerleave', function () { el.style.setProperty('--ry', '0deg'); el.style.setProperty('--rx', '0deg'); });
    });
  }
  var cv = document.createElement('canvas'), cx = cv.getContext('2d', { willReadFrequently: true });
  function measure(img) {
    if (img.__tadf) return; var src = img.currentSrc || img.src; if (!src) return; img.__tadf = 1;
    var pr = new Image(); pr.crossOrigin = 'anonymous';
    pr.onload = function () {
      try {
        var W = 120, H = Math.max(1, Math.round(120 * pr.naturalHeight / pr.naturalWidth));
        cv.width = W; cv.height = H; cx.clearRect(0, 0, W, H); cx.drawImage(pr, 0, 0, W, H);
        var d = cx.getImageData(0, 0, W, H).data, i, k;
        var corners = [0, (W - 1) * 4, (H - 1) * W * 4, ((H - 1) * W + W - 1) * 4];
        for (i = 0; i < 4; i++) { k = corners[i]; if (d[k + 3] > 10 && (d[k] < 232 || d[k + 1] < 232 || d[k + 2] < 232)) return; }
        var x0 = W, y0 = H, x1 = -1, y1 = -1, x, y;
        for (y = 0; y < H; y++) for (x = 0; x < W; x++) { k = (y * W + x) * 4; if (d[k + 3] > 20 && (765 - d[k] - d[k + 1] - d[k + 2]) > 40) { if (x < x0) x0 = x; if (x > x1) x1 = x; if (y < y0) y0 = y; if (y > y1) y1 = y; } }
        if (x1 < 0) return;
        var box = img.parentElement.getBoundingClientRect(); if (!box.width || !box.height) return;
        var cA = box.width / box.height, ar = W / H;
        var rwF = ar > cA ? 1 : ar / cA, rhF = ar > cA ? cA / ar : 1;
        var fw = (x1 - x0 + 1) / W, fh = (y1 - y0 + 1) / H, cxF = ((x0 + x1 + 1) / 2) / W - .5, cyF = ((y0 + y1 + 1) / 2) / H - .5;
        var s = Math.min(.84 / (fw * rwF), .70 / (fh * rhF)); s = Math.max(.7, Math.min(1.9, s));
        var tx = -cxF * rwF * s * 100, ty = -cyF * rhF * s * 100;
        img.style.setProperty('--tad-fit', 'translate(' + tx.toFixed(2) + '%,' + ty.toFixed(2) + '%) scale(' + s.toFixed(3) + ')');
        img.classList.add('is-fit');
      } catch (e) {}
    };
    pr.src = src;
  }
  function frame(root) {
    (root || document).querySelectorAll('.card-wrapper .card__media .media img, .tad-card__media img').forEach(function (img) {
      if (img.complete && img.naturalWidth) measure(img); else img.addEventListener('load', function () { measure(img); }, { once: true });
    });
  }
  function all(root) { marquee(root); tilt(root); frame(root); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { all(); }); else all();
  document.addEventListener('shopify:section:load', function (e) { all(e.target); });
  var mo = new MutationObserver(function (list) { list.forEach(function (m) { m.addedNodes.forEach(function (n) { if (n.nodeType === 1) frame(n); }); }); });
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();

/* close the mobile drawer when an in-page anchor (e.g. /#youtube) is tapped */
document.addEventListener('click', function (e) {
  var a = e.target.closest && e.target.closest('#TadDrawer a[href*="#"]'); if (!a) return;
  var d = document.getElementById('TadDrawer'); var b = d && d.querySelector('button[data-drawer-close]'); if (b) b.click();
});
